const print = (contenido) => {
    const ventanaImpresion = window.open('', '', 'height=600,width=800');
    ventanaImpresion.document.write('<html><head><title>Imprimir Etiqueta</title>');
    ventanaImpresion.document.write('<style>@media print { body { margin: 0; padding: 0; } }</style>');
    ventanaImpresion.document.write('</head><body>');
    ventanaImpresion.document.write(contenido);
    ventanaImpresion.document.write('</body></html>');
    ventanaImpresion.document.close();
    ventanaImpresion.focus();
    ventanaImpresion.print();
    ventanaImpresion.close();
};

const PrintService = {
    print
};

export default PrintService